<template>
  <v-expansion-panels v-model="paramter_panel" accordion class="accordion">

    <!-- paramter_panel[0]: source -->
    <v-expansion-panel v-if="visible_panel.indexOf('source') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.common.source") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                {{ make_title('source') }}
              </span>
              <span v-if="!open && !make_title('source')" class="text--secondary">
                {{ $t("message.common.select_text") }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-tabs
          background-color="primary"
          dark
          v-model="source_tab"
          @change="reset_source_tab"
        >
          <v-tab href="#new_file">
            {{ $t("message.common.new_file") }}
          </v-tab>
          <v-tab href="#uploaded_file">
            {{ $t("message.common.uploaded_file") }}
          </v-tab>

          <!-- source_tab[0]: new_file -->
          <v-tabs-items v-model="source_tab">
            <v-tab-item value="new_file">
              <v-card class="pa-5">
                <Upload
                  ref="upload"
                  type="source"
                  :valid="files_valid"
                  :multiple="false"
                  :max_files="1"
                  v-on:update_files_valid="files_valid = $event"
                  v-on:done_upload="$emit('done_upload', $event)"
                  :upload_detail="upload_detail_parm"
                >
                </Upload>
              </v-card>
            </v-tab-item>

            <!-- source_tab[1]: uploaded_file -->
            <v-tab-item value="uploaded_file">
              <v-card class="mb-1 mt-1">
                <FileSelect
                  :selected_file="uploaded_files"
                  file_type="source"
                  :multiple="false"
                  :select_one="true"
                  :max_select="1"
                  :show_select="true"
                  initital_fid=""
                  v-on:update_files_select="uploaded_files = $event"
                ></FileSelect>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[1]: title -->
    <v-expansion-panel v-if="visible_panel.indexOf('title') !== -1">
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.common.title") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                {{ make_title('title') }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-text-field
          :label="$t('message.common.title')"
          v-model="parameters.title"
          :rules="[
            v => (v && v.length <= 80) || $t('message.common.over_text', { length: 80 })
          ]"
          counter="80"
        >
        </v-text-field>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- paramter_panel[2]: field/model -->
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row>
            <v-col cols="4">
              {{ $t("message.similarity.model") }}
            </v-col>
            <v-col cols="8">
              <span v-if="!open">
                <template v-if="target_tab === 'model' && selected_model.length > 0">
                  {{ $t("message.common.model") }}:&nbsp;
                  {{ selected_model.length > 0 ? (selected_model[0].name ? selected_model[0].name.replace(/\([A-Z]\d{5,8}\)/g, "") + "(" + selected_model[0].mid + ")" : selected_model[0].mid) : "" }}
                </template>
                <template v-else-if="selected_corpus.length > 0">
                  {{ $t("message.common.corpus") }}:&nbsp;
                  {{ selected_corpus.length > 0 ? (selected_corpus[0].name ? selected_corpus[0].name.replace(/\([A-Z]\d{5,8}\)/g, "") + "(" + selected_corpus[0].cid + ")" : selected_corpus[0].cid) : "" }}
                </template>
              </span>
              <span v-if="!open && selected_model.length <= 0 && selected_corpus.length <= 0" class="text--secondary">
                {{ $t("message.common.select_text") }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-tabs
          background-color="primary"
          dark
          v-model="target_tab"
          @change="reset_target_tab"
        >
          <v-tab href="#model">
            {{ $t("message.common.model") }}
          </v-tab>
          <v-tab href="#corpus">
            {{ $t("message.common.corpus") }}
          </v-tab>

          <v-tabs-items v-model="target_tab">
            <v-tab-item value="model">
              <ModelSelect
                :selected_model="selected_model"
                :source_lang="null"
                :target_lang="null"
                :multiple="true"
                :select_one="true"
                :max_select="20"
                :show_select="true"
                initital_mid=""
                v-on:update_model_select="selected_model = $event"
                :mode="mode"
              ></ModelSelect>
            </v-tab-item>
            <v-tab-item value="corpus">
              <CorpusSelect
                :selected_corpus="selected_corpus"
                :show_select="true"
                :multiple="true"
                :select_one="true"
                :max_select="20"
                initital_cid=""
                v-on:update_corpuses_select="selected_corpus = $event"
                upload_refer="similarity"
              ></CorpusSelect>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Upload from '../components/Upload';
import FileSelect from '../components/FileSelect';
import ModelSelect from '../components/ModelSelect';
import CorpusSelect from '../components/CorpusSelect';
import { http_error } from "../js/http_error";

export default {
  name: 'similarity_parameter',
  components: {
    Upload,
    FileSelect,
    ModelSelect,
    CorpusSelect
  },
  mixins: [http_error],
  props: {
    visible_panel: Array,
    mode: String
  },
  data: function(){
    return {
      module_id: "78",

      // common
      paramter_panel: 0,
      sources: [],
      parameters: {
        title: "",
        source: null,
        target: null,
        target_type: null
      },

      // paramter_panel[0]: source
      source_tab: "new_file",
      //// source_tab[0]: new_file
      files_valid: true,
      //// source_tab[1]: uploaded_file
      uploaded_files: [],

      // paramter_panel[2]: target
      target_tab: "model",
      selected_model: [],
      selected_corpus: [],
      upload_detail_parm:{
        target: 'source',
        additional: true,
        size: 300,
        count: 200000,
        files: 1
      }
    }
  },
  computed: {
    similaritable: function(){
      return ((this.source_tab === 'new_file' && !this.files_valid)
        || (this.source_tab === 'uploaded_file' && this.uploaded_files.length > 0))
        && this.parameters.title.length <= 80
        && ((this.target_tab === 'model' && this.selected_model.length > 0 && this.selected_model.length <= 20)
        || (this.target_tab === 'corpus' && this.selected_corpus.length > 0 && this.selected_corpus.length <= 20));
    }
  },
  methods: {
    make_title: function(panel_name){
      if(panel_name === "title" && this.parameters.title){
        return this.parameters.title;
      }
      var result = "";
      switch(this.source_tab){
        case "new_file":
          if(this.$refs.upload && this.$refs.upload.files){
            if(Array.isArray(this.$refs.upload.files)){
              if(this.$refs.upload.files.length > 0){
                result = this.$refs.upload.files[0].name;
                if(this.$refs.upload.files.length > 1){
                  result += ", ...";
                }
              }
            }else{
              result = this.$refs.upload.files.name;
            }
          }
          break;
        case "uploaded_file":
          if(this.uploaded_files && this.uploaded_files.length > 0){
            if(this.uploaded_files[0].name){
              result = this.uploaded_files[0].name
                     + "(" + this.uploaded_files[0].fid + ")";
            }else{
              result = this.uploaded_files[0].fid;
            }
            if(this.uploaded_files.length > 1){
              result += ", ..."
            }
          }
          break;
      }
      return result;
    },
    reset_source_tab: function(){
      if(this.$refs.upload){
        this.$refs.upload.files = null;
      }
      this.uploaded_files = [];
    },
    reset_target_tab: function(){
      this.selected_model = [];
      this.selected_corpus = [];
    },
  },
  watch: {
    similaritable: {
      handler: function (val, oldVal) {
        this.$emit("update_similaritable", val);
      }
    }
  }
}
</script>
<style scoped>
.accordion{
  border-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.v-expansion-panel::before{
  box-shadow: none;

}
</style>
